import { AppUpdateService } from "@Services/AppUpdated.Service"
import { useState } from "react"

export const useAppUpdateHooks = () => {
    const [lastAppUpdate, setLastAppUpdate] = useState({})
    const [fetching, setFetching] = useState({})

    const fetchLastAppUpdate = () => {
        setFetching(true)
        AppUpdateService.GetLastAppUpdated()
            .then((response) => {
                const data = response?.data
                if (data) {
                    setLastAppUpdate(data)
                }
                setFetching(false)
            })
            .catch((e) => {
                console.log({ errorFetchingUpdateVersion: e })
                setFetching(false)
            })
    }

    return {
        fetchLastAppUpdate,
        lastAppUpdate,
        fetching
    }
}
